<template>
  <div>
    <h2>
      Lịch sử
    </h2>
    <div class="mt-4">
      <div class="history-log__text history-wrapper">
        <div v-for="(data, index) in history" :key="index">
          <div class="d-flex text-content pb-2" :class="{ 'error--text': index === 0 }">
            <div class="text-content__icon mr-4">
              <v-icon color="#000000" small>mdi-circle</v-icon>
            </div>
            <div>
              <div>
                {{ get(data, 'user.role', '') | getRole }} {{ get(data, 'user.name', '--') }} cập nhập lịch nhập ngày
                {{ moment(get(data, 'createdAt', '')).format('DD/MM/YYYY') }} (lúc
                {{ moment(get(data, 'createdAt', '')).format('HH:mm') }})
              </div>
            </div>
          </div>
        </div>
        <div class="d-flex">
          <v-icon class="mr-4" color="#000000" small>mdi-circle</v-icon>
          <div>
            {{
              `Hệ thống tự động tạo nội dung nhập ngày ${moment(get(item, 'createdAt', '')).format(
                'DD/MM/YYYY'
              )} (lúc ${moment(get(item, 'createdAt', '')).format('HH:mm')})`
            }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import { get } from 'lodash'
import { mapState } from 'vuex'
export default {
  data() {
    return {
      moment,
      get
    }
  },
  computed: {
    ...mapState('importDeliveries', ['history']),
    ...mapState('importDeliveries', ['item'])
  }
}
</script>

<style lang="scss" scoped>
.history-wrapper {
  width: 100%;
}
</style>
